module.exports = __webpack_public_path__ + "media/images/icon__close--rb-white@2x-4df9f5f899fb35481ad97fb25d7aa810.png";